mutation CreateProductsCsv {
    productsExport {
        url
    }
}
